import React from "react";

const ErrorCircleIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
  <path d="M7.49935 4.66699V7.00033M7.49935 9.33366H7.50518M13.3327 7.00033C13.3327 10.222 10.721 12.8337 7.49935 12.8337C4.27769 12.8337 1.66602 10.222 1.66602 7.00033C1.66602 3.77866 4.27769 1.16699 7.49935 1.16699C10.721 1.16699 13.3327 3.77866 13.3327 7.00033Z" stroke="#EF404B" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
</svg>);

export default ErrorCircleIcon;
